/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-no-undef */
import { RouteObject } from 'react-router-dom';
import { employeeUpdateLoader } from 'loaders/employeeUpdateLoader';
import { driverUpdateLoader } from 'loaders/driverUpdateLoader';
import { commonLoader } from 'loaders/commonLoader';
import apiEndpoints from 'constants/apiEndpoints';
import Protected from 'components/auth/Protected';

import { lazy, Suspense } from 'react';
const ManualPunchList = lazy(
  () => import('pages/hrms/manual-punch/manual-punch-list/ManualPunchList')
);

// Lazy loading the components
const EmployeeList = lazy(
  () => import('pages/hrms/employee/employee-list/EmployeeList')
);
// const EmployeeDetail = lazy(() => import('pages/hrms/employee/EmployeeDetail'));
import EmployeeDetail from 'pages/hrms/employee/EmployeeDetail';
import SeparatedEmployee from 'pages/hrms/separatedEmployee/separatedEmployee-list/SeparatedEmployee';
import HRReports from 'pages/hrms/reports/HRReports';
const CreateEmployeePage = lazy(
  () => import('pages/hrms/employee/CreateEmployeePage')
);
const DriverList = lazy(
  () => import('pages/hrms/driver/driver-list/DriverList')
);
const CreateDriverPage = lazy(
  () => import('pages/hrms/driver/CreateDriverPage')
);
const DriverDetail = lazy(() => import('pages/hrms/driver/DriverDetail'));
const LeaveList = lazy(() => import('pages/hrms/leave/LeaveList'));
const RunPayrollEmployee = lazy(
  () => import('pages/hrms/payroll/employee/RunPayroll')
);
const RunPayrollDriver = lazy(
  () => import('pages/hrms/payroll/driver/RunPayroll')
);
const PayrollDriver = lazy(
  () => import('pages/hrms/payroll/driver/PayrollDriver')
);
const PayrollEmployee = lazy(
  () => import('pages/hrms/payroll/employee/PayrollEmployee')
);
const EmployeeAttendance = lazy(
  () => import('pages/hrms/attendence/employee/EmployeeAttendance')
);
const DriverAttendance = lazy(
  () => import('pages/hrms/attendence/driver/DriverAttendance')
);

export function SuspenseWrapper({ children }: { children: any }) {
  return <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>;
}

const hrmsRoutes: RouteObject[] = [
  {
    path: 'employee',
    children: [
      {
        index: true,
        element: (
          <Protected action="view" module={'Employee'}>
            <SuspenseWrapper>
              <EmployeeList />
            </SuspenseWrapper>
          </Protected>
        )
      },
      {
        path: 'detail/:id',
        element: (
          <Protected action="view" module={'Employee'}>
            <SuspenseWrapper>
              <EmployeeDetail />
            </SuspenseWrapper>
          </Protected>
        ),
        loader: ({ params }) =>
          commonLoader({
            params,
            apiEndpoints: apiEndpoints.employee.getById
          })
      },
      {
        path: 'new',
        element: (
          <Protected action="maker" module={'Employee'}>
            <SuspenseWrapper>
              <CreateEmployeePage isUpdate={false} />
            </SuspenseWrapper>
          </Protected>
        )
      },
      {
        path: 'update/:id',
        element: (
          <Protected action="edit" module={'Employee'}>
            <SuspenseWrapper>
              <CreateEmployeePage isUpdate={true} />
            </SuspenseWrapper>
          </Protected>
        ),
        loader: employeeUpdateLoader
      }
    ]
  },
  {
    path: 'separated_employee',
    children: [
      {
        index: true,
        element: (
          <Protected action="view" module={'Separated Employee'}>
            <SuspenseWrapper>
              <SeparatedEmployee />
            </SuspenseWrapper>
          </Protected>
        )
      }
    ]
  },
  {
    path: 'driver',
    children: [
      {
        index: true,
        element: (
          <Protected action="view" module={'Driver'}>
            <SuspenseWrapper>
              <DriverList />
            </SuspenseWrapper>
          </Protected>
        )
      },
      {
        path: 'detail/:id',
        element: (
          <Protected action="view" module={'Driver'}>
            <SuspenseWrapper>
              <DriverDetail />
            </SuspenseWrapper>
          </Protected>
        ),
        loader: ({ params }) =>
          commonLoader({
            params,
            apiEndpoints: apiEndpoints.driver.getById
          })
      },
      {
        path: 'new',
        element: (
          <Protected action="maker" module={'Driver'}>
            <SuspenseWrapper>
              <CreateDriverPage isUpdate={false} />
            </SuspenseWrapper>
          </Protected>
        )
      },
      {
        path: 'update/:id',
        element: (
          <Protected action="edit" module={'Driver'}>
            <SuspenseWrapper>
              <CreateDriverPage isUpdate={true} />
            </SuspenseWrapper>
          </Protected>
        ),
        loader: driverUpdateLoader
      }
    ]
  },
  {
    path: 'leave',
    element: (
      <Protected action="view" module={'Leave'}>
        <SuspenseWrapper>
          <LeaveList />
        </SuspenseWrapper>
      </Protected>
    )
  },
  {
    path: 'manualPunch',
    element: (
      <Protected action="view" module={'Manual Punch'}>
        <SuspenseWrapper>
          <ManualPunchList />
        </SuspenseWrapper>
      </Protected>
    )
  },
  {
    path: 'hr_report',
    element: (
      <Protected action="view" module={'All'}>
        <SuspenseWrapper>
          <HRReports />
        </SuspenseWrapper>
      </Protected>
    )
  },
  // {
  //   path: 'attendance/:tab',
  //   element: (
  //     <Protected action="view" module={'attendance'}>
  //       <SuspenseWrapper><Attendance /></SuspenseWrapper>
  //     </Protected>
  //   )
  // },
  {
    path: 'attendance',
    children: [
      {
        path: 'driver',
        children: [
          {
            path: ':tab',
            element: (
              <Protected action="view" module={'Driver Attendance'}>
                <SuspenseWrapper>
                  <DriverAttendance />
                </SuspenseWrapper>
              </Protected>
            )
          }
          // {
          //   path: 'attendance-detail/:id',
          //   element: (
          //     <Protected action="view" module={'driver_attendance'}>
          //       <SuspenseWrapper><DriverMonthlyAttendance /></SuspenseWrapper>
          //     </Protected>
          //   )
          // }
        ]
      },
      {
        path: 'employee',
        children: [
          {
            path: ':tab',
            element: (
              <Protected action="view" module={'Employee Attendance'}>
                <SuspenseWrapper>
                  <EmployeeAttendance />
                </SuspenseWrapper>
              </Protected>
            )
          }
          // {
          //   path: 'attendance-detail/:id',
          //   element: (
          //     <Protected action="view" module={'employee_attendance'}>
          //       <SuspenseWrapper><EmployeeMonthlyAttendance /></SuspenseWrapper>
          //     </Protected>
          //   )
          // }
        ]
      }
    ]
  },
  {
    path: 'payrolls',
    children: [
      {
        path: 'driver',
        children: [
          {
            path: ':tab',
            element: (
              <Protected action="view" module={'Driver Payrolls'}>
                <SuspenseWrapper>
                  <PayrollDriver />
                </SuspenseWrapper>
              </Protected>
            )
          },
          {
            path: 'payroll-detail/:id',
            element: (
              <Protected action="view" module={'Driver Payrolls'}>
                <SuspenseWrapper>
                  <RunPayrollDriver />
                </SuspenseWrapper>
              </Protected>
            )
          }
        ]
      },
      {
        path: 'employee',
        children: [
          {
            path: ':tab',
            element: (
              <Protected action="view" module={'Employee Payrolls'}>
                <SuspenseWrapper>
                  <PayrollEmployee />
                </SuspenseWrapper>
              </Protected>
            )
          },
          {
            path: 'payroll-detail/:id',
            element: (
              <Protected action="view" module={'Employee Payrolls'}>
                <SuspenseWrapper>
                  <RunPayrollEmployee />
                </SuspenseWrapper>
              </Protected>
            )
          }

          // {
          //   path: 'check-payroll',
          //   element: (
          //     <Protected action="view" module={'employee_payroll'}>
          //       <SuspenseWrapper><CheckPayroll /></SuspenseWrapper>
          //     </Protected>
          //   )
          // },
          // {
          //   path: 'pay-payroll',
          //   element: (
          //     <Protected action="view" module={'employee_payroll'}>
          //       <SuspenseWrapper><PayPayroll /></SuspenseWrapper>
          //     </Protected>
          //   )
          // }
        ]
      }

      // {
      //   index: true,
      //   element: (
      //     <Protected action="view" module={'paid_payroll'}>
      //       <SuspenseWrapper><PaidPayroll /></SuspenseWrapper>
      //     </Protected>
      //   )
      // }
    ]
  }
];

export default hrmsRoutes;
